import { render, staticRenderFns } from "./BRGovCorp.vue?vue&type=template&id=bb2e08b8&"
import script from "./BRGovCorp.vue?vue&type=script&lang=js&"
export * from "./BRGovCorp.vue?vue&type=script&lang=js&"
import style0 from "./BRGovCorp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports